import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import WebApp from '@twa-dev/sdk';
import { v1 } from 'uuid';
import copy from 'copy-to-clipboard';
import { useUnit } from 'effector-react';
import { historyState, setShowHistory } from '../../../../features/history/model';
import SimpleBox from '../../../../shared/lib/images/boxes/simple_box.png';
import RareBox from '../../../../shared/lib/images/boxes/rare_box.png';
import EpicBox from '../../../../shared/lib/images/boxes/epic_box.png';
import LegendaryBox from '../../../../shared/lib/images/boxes/legendary_box.png';
import DemonBox from '../../../../shared/lib/images/boxes/demon_box.png';
import HackerBox from '../../../../shared/lib/images/boxes/hacker_box.png';
import MetaBox from '../../../../shared/lib/images/boxes/meta_box.png';
import Ordinary from '../../../../shared/lib/images/boxes/preview/ordinary.png';
import { Alert, Button, SkeletonInfo } from '../../../../shared/ui/components';
import { SvgSelector } from '../../../../shared/lib/assets/svg-selector';
import { convertTimestampToDate } from '../../../../shared/utils/formatDate';
import { formatNumber } from '../../../../shared/utils/formatNumber';
import ARBUZ from '../../../../shared/lib/images/arbuz.svg';
import DFC from '../../../../shared/lib/images/dfc.svg';
import s from './history-list.module.scss';
export const HistoryList = () => {
    const TgObj = WebApp;
    const { t } = useTranslation();
    const [isCopiedLink, setIsCopiedLink] = useState(false);
    const { historyData, isLoading } = useUnit(historyState);
    const handleBack = () => {
        TgObj.BackButton.hide();
        setShowHistory(false);
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        TgObj.BackButton.show();
        TgObj.BackButton.onClick(handleBack);
        return () => {
            TgObj.BackButton.offClick(handleBack);
        };
    }, []);
    const getCasePreviewData = (id) => {
        switch (id) {
            case 1:
                return (SimpleBox);
            case 2:
                return (RareBox);
            case 3:
                return (EpicBox);
            case 4:
                return (LegendaryBox);
            case 5:
                return (DemonBox);
            case 6:
                return (HackerBox);
            case 7:
                return (MetaBox);
            default:
                SimpleBox;
        }
    };
    const getCaseTitle = (id) => {
        switch (id) {
            case 1:
                return ('cases.ordinary');
            case 2:
                return ('cases.rare');
            case 3:
                return ('cases.epic');
            case 4:
                return ('cases.legendary');
            case 5:
                return ('cases.demon');
            case 6:
                return ('cases.hacker');
            case 7:
                return ('cases.meta');
            default:
                'cases.ordinary';
        }
    };
    const handleCopyWin = (type, link) => {
        if (type !== 'DFC' && type !== 'ARBUZ')
            return;
        setIsCopiedLink(true);
        copy(link);
    };
    return (_jsxs("div", { className: s.history, children: [isCopiedLink && (_jsx(Alert, { type: "important", onClose: () => setIsCopiedLink(false), icon: _jsx(_Fragment, { children: "\uD83D\uDCC3" }), autoCloseTimeout: 1000, position: "top-right", className: s.alert, children: t('check.alert') })), _jsx("h2", { className: s.historyTitle, children: t('common.history-title') }), _jsx("div", { className: s.historyBody, children: isLoading ? (new Array(8).fill(null).map(_ => (_jsxs("li", { className: s.historyItem, children: [_jsx("div", { className: s.historyItemPreview }), _jsxs("div", { className: s.historyItemBody, children: [_jsxs("div", { className: s.historyItemInfo, children: [_jsx("div", { className: s.historyItemTitle, children: _jsx(SkeletonInfo, { height: "15" }) }), _jsx("div", { className: `${s.historyItemResult} ${s.historyItemResultSvg}`, children: _jsx(SkeletonInfo, { height: "15" }) })] }), _jsx("div", { className: s.historyItemDate, children: _jsx(SkeletonInfo, { height: "15" }) })] })] }, v1())))) : (_jsx(_Fragment, { children: historyData && historyData?.length >= 1 ? (_jsx("ul", { className: `${historyData?.length >= 1 ? s.historyList : ''}`, children: historyData.map(el => (_jsxs("li", { className: s.historyItem, style: { cursor: (el.winType === 'DFC' || el.winType === 'ARBUZ') ? 'pointer' : '' }, onClick: () => handleCopyWin(el.winType, el.receiptLink), children: [_jsx("img", { src: getCasePreviewData(el.caseId), alt: el.winType }), _jsxs("div", { className: s.historyItemBody, children: [_jsxs("div", { className: s.historyItemInfo, children: [_jsx("p", { className: s.historyItemTitle, children: t(getCaseTitle(el.caseId) ?? '') }), _jsxs("div", { className: s.historyItemResult, children: [(el.winType === 'DFC' || el.winType === 'ARBUZ') && (_jsxs(_Fragment, { children: [el.winType === 'DFC' && _jsx(DFC, {}), el.winType === 'ARBUZ' && _jsx(ARBUZ, {}), el.amount] })), el.winType === 'LEVEL' && (_jsxs(_Fragment, { children: [_jsx(SvgSelector, { id: "level-20" }), t('common.level')] })), el.winType === 'COIN' && (_jsxs(_Fragment, { children: [_jsx(SvgSelector, { id: "logo-coin-17" }), formatNumber(el.amount)] }))] })] }), _jsxs("p", { className: s.historyItemDate, children: [convertTimestampToDate(el.createdAt), (el.winType === 'DFC' || el.winType === 'ARBUZ') && _jsx(SvgSelector, { id: "copy" })] })] })] }, v1()))) })) : (_jsxs("div", { className: s.historyEmpty, children: [_jsx("img", { src: Ordinary, alt: "preview" }), _jsx("p", { children: t('empty-history.title') }), _jsx(Button, { onClick: handleBack, children: t('empty-history.button') })] })) })) })] }));
};
